import { BusinessLine } from '../types/definitions/vendor/graphql-schema.d';

const hasUnsafeReturnUrlCharacters = (value: string) =>
  Array.from(value).some(char => {
    const charCode = char.charCodeAt(0);

    return char === '\\' || charCode < 32 || charCode === 127;
  });

const isHexDigit = (value: string) => /^[\da-f]$/i.test(value);

const hasInvalidPercentEscape = (value: string) => {
  for (let index = 0; index < value.length; index += 1) {
    if (value[index] === '%') {
      const firstHexDigit = value[index + 1];
      const secondHexDigit = value[index + 2];

      if (
        !firstHexDigit ||
        !secondHexDigit ||
        !isHexDigit(firstHexDigit) ||
        !isHexDigit(secondHexDigit)
      ) {
        return true;
      }

      const charCode = Number.parseInt(`${firstHexDigit}${secondHexDigit}`, 16);

      if (charCode < 32 || charCode === 92 || charCode === 127) return true;
    }
  }

  return false;
};

/**
 * Returns a root-relative internal URL without decoding it, preserving embedded
 * path escapes. Unsafe, malformed, external, and absent values use the caller's
 * fallback instead.
 */
export const sanitizeReturnUrl = (
  value: string | string[] | null | undefined,
  fallback = '/gallery',
): string => {
  const raw = Array.isArray(value) ? value[0] : value;

  if (!raw || raw.trim() !== raw) return fallback;

  if (
    !raw.startsWith('/') ||
    raw.startsWith('//') ||
    /^[a-z][a-z\d+.-]*:/i.test(raw) ||
    hasUnsafeReturnUrlCharacters(raw) ||
    hasInvalidPercentEscape(raw)
  ) {
    return fallback;
  }

  return raw;
};

export type BusinessLineRoutes = 'women' | 'men';
export const businessLineToRoute = {
  WOMENS: 'women',
  MENS: 'men',
  KIDS: 'kids',
  SHELL: 'shell',
};
export const routeToBusinessLine: Record<string, BusinessLine> = {
  women: 'WOMENS',
  men: 'MENS',
  kids: 'KIDS',
  shell: 'SHELL',
};
export const routeToBusinessLineDisplay = (businessLine: BusinessLineRoutes) =>
  ({
    kids: 'Kids',
    men: 'Men',
    women: 'Women',
  }[businessLine]);

export const matchBusinessLineRoute = ({
  businessLine,
  route,
}: {
  businessLine: BusinessLine;
  route: BusinessLineRoutes;
}) => businessLineToRoute[businessLine] === route;
